import styled from '@emotion/styled';
import Colors from '../theme/colors';

export const Text6 = styled.span`
  color: ${Colors.gray_3};
  font-size: 16px;
  font-weight: 600;
  line-height: 130%; /* 20.8px */
  letter-spacing: -0.32px;

  @media print {
    font-size: 12px;
  }
`;
